import React from 'react';

import { Typography, List, ListItem, ListItemText } from '@mui/material';

import CommentContent from './CommentContent';

import { sxStyle } from './styles';

const CommentsSection = ({
  title,
  items,
  sectionKey,
  seeTitle = false,
  marginTop = 0,
}) => {
  if (!items?.length) {
    return null;
  }

  return (
    <>
      {seeTitle && (
        <Typography sx={sxStyle.title} mt={marginTop}>
          {title}
        </Typography>
      )}

      <List>
        {items.map((item, i) => (
          <ListItem key={`${sectionKey}-${i}`} sx={{ padding: 0 }}>
            <ListItemText primary={<CommentContent>{item}</CommentContent>} />
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default CommentsSection;
